import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Shippment } from '../../models/shippment/shippment-model';
import { ShippmentService } from '../../services/shippment/shippment-setting';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ProfileService } from '../../services/profile/profile.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-shipping-method',
  templateUrl: './create-shipping-method.component.html',
  styleUrls: ['./create-shipping-method.component.css']
})
/** create-shipping-method component*/
export class CreateShippingMethodComponent {
  /** create-shipping-method ctor */
  public shippment = new Shippment();
  fileToUpload: File;
  fd = new FormData();
  public mediaList: MediaLibrary[];
  userId: number;
  mediaImageShow: boolean;
  selectedShippmentLogo: string;
  validate: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly shippmentService: ShippmentService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("shippingmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.validate = true;
            this.mediaImageShow = true;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
            this.shippment.isActive = true;
          }
          else {
            this.router.navigate(["/shipping-methods"]);
          }
        }
        else {
          this.router.navigate(["/shipping-methods"]);
        }
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.mediaImageShow = true;
    this.selectedShippmentLogo = "";
    this.shippment.logo = "";
    this.shippment.logo = Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    this.selectedShippmentLogo = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }
        
      }
    )
  }
  uploadShippmentLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("ShippmentLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.shippment.logo = "";
      this.mediaImageShow = true;
      this.selectedShippmentLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  HidePopup() {
    this.selectedShippmentLogo = "";
    this.shippment.logo = "";
    this.modalRef.hide();
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.shippment.url = Value.toLowerCase();
  }
  isActiveCheckbox(e) {
    this.shippment.isActive = e.target.checked;
  }
 isDefaultCheckbox(e) {
    this.shippment.isDefault = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.shippmentService.AddShippment(this.shippment).subscribe(result => {
      if (result) {
        this.toastr.success('Shippmernt Method has been Saved. ', 'Success');
        this.fd.append("ShippingMethodID", result.toString());
        this.shippmentService.AddShippmentLogo(this.fd, this.userId);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shipping-components/create-shipping-method/create-shipping-method.component.ts